import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { SQ, EN } from "./translations";

const STORAGE_KEY = "cfc-lang";
const LanguageContext = createContext(null);

function readStoredLang() {
  if (typeof window === "undefined") return "sq";
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "en" ? "en" : "sq";
  } catch {
    // localStorage can throw in private-browsing/locked-down contexts.
    return "sq";
  }
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(readStoredLang);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      // Nothing to do — the toggle still works for the current visit.
    }
  }, [lang]);

  const value = useMemo(() => {
    const t = lang === "en" ? EN : SQ;
    return {
      lang,
      t,
      isSq: lang === "sq",
      isEn: lang === "en",
      setSq: () => setLang("sq"),
      setEn: () => setLang("en"),
    };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return ctx;
}
